import { consoleTranslations, sharedTranslations } from '@gisify/i18n'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const resources = {
  en: {
    shared: sharedTranslations.en,
    console: consoleTranslations.en,
  },
  ms: {
    shared: sharedTranslations.ms,
    console: consoleTranslations.ms,
  },
  zh: {
    shared: sharedTranslations.zh,
    console: consoleTranslations.zh,
  },
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    defaultNS: 'shared',
    ns: ['shared', 'console'],
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  })
  .catch(error => {
    console.error('i18n initialization error:', error)
  })

export default i18n
